import React, { useEffect, useState, useMemo } from "react";
import { Modal, Button, Form, Badge, Card, Table, Spinner, Row, Col } from 'react-bootstrap';
import Menu from '../../comum/Menu/menu.jsx';
import Footer from '../../comum/Footer/index.jsx';
import { api } from '../../services/api.js';
import Foto from "../Components/Foto";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import {
    FaSearch,
    FaFilter,
    FaHistory,
    FaTimes,
    FaEye,
    FaStore,
    FaChevronDown
} from "react-icons/fa";

const fotoCache = new Map();

// Componente para a foto em miniatura (avatar) ao lado da matrícula
const FotoAvatarMini = ({ chapa, nome, filial, onSelectFoto }) => {
    const [fotoSrc, setFotoSrc] = useState(null);

    useEffect(() => {
        if (!chapa) return;
        let isMounted = true;
        const hoje = new Date().toISOString().slice(0, 10);
        const chave = `func_${chapa}_${hoje}`;

        if (fotoCache.has(chave)) {
            setFotoSrc(fotoCache.get(chave));
            return;
        }

        api.get(`/usuario/foto/${chapa}`)
            .then(res => {
                if (isMounted && res?.data?.foto) {
                    fotoCache.set(chave, res.data.foto);
                    setFotoSrc(res.data.foto);
                }
            })
            .catch(() => { });

        return () => { isMounted = false; };
    }, [chapa]);

    const handleClick = (e) => {
        if (e) e.stopPropagation();
        if (fotoSrc && onSelectFoto) {
            onSelectFoto({
                foto: `data:image/jpeg;base64,${fotoSrc}`,
                nome: nome || "",
                info01: `Matrícula: ${chapa}`,
                info02: `Loja ${String(filial || '').padStart(2, '0')}`
            });
        }
    };

    return (
        <div
            onClick={handleClick}
            style={{
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                backgroundColor: '#e9ecef',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: fotoSrc ? 'pointer' : 'default',
                overflow: 'hidden',
                flexShrink: 0,
                border: '1px solid #dee2e6'
            }}
        >
            {fotoSrc ? (
                <img
                    src={`data:image/jpeg;base64,${fotoSrc}`}
                    alt="foto"
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
            ) : (
                <span style={{ fontSize: '0.8rem' }}>👤</span>
            )}
        </div>
    );
};

const formatarDataSemFuso = (dataStr) => {
    if (!dataStr) return '--';
    const trechoData = dataStr.substring(0, 10);
    const partes = trechoData.split('-');
    if (partes.length !== 3) return dataStr;
    const [ano, mes, dia] = partes;
    return `${dia}/${mes}/${ano}`;
};

const formatMoeda = (valor) => valor ? Number(valor).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) : 'R$ 0,00';

const getBadgeStatus = (status) => {
    const st = Number(status);
    switch (st) {
        case 1: return <Badge bg="primary">1 - Em Aprov. Regional</Badge>;
        case 2: return <Badge bg="warning" text="dark">2 - Em Validação RH</Badge>;
        case 3: return <Badge bg="info">3 - Em Aprov. Dependentes</Badge>;
        case 4: return <Badge bg="dark">4 - Em Aprov. Diretoria</Badge>;
        case 5: return <Badge bg="secondary">5 - Lançamento RH</Badge>;
        case 6: return <Badge bg="info">6 - Ciência do Func.</Badge>;
        case 10: return <Badge bg="success">10 - Concluído</Badge>;
        case 11: return <Badge bg="danger">11 - Negado Loja Destino</Badge>;
        case 12: return <Badge bg="danger">12 - Negado Regional</Badge>;
        case 13: return <Badge bg="danger">13 - Negado RH</Badge>;
        default: return <Badge bg="secondary">Status {status}</Badge>;
    }
};

function ConsultaGerente() {
    const navigate = useNavigate();
    const ITENS_POR_PAGINA = 30;

    const [comunicados, setComunicados] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingLog, setLoadingLog] = useState(false);

    // Controle de Paginação
    const [limiteExibicao, setLimiteExibicao] = useState(ITENS_POR_PAGINA);

    // Lojas Permitidas e Seleção
    const [lojasPermitidas, setLojasPermitidas] = useState([]);
    const [lojaSelecionada, setLojaSelecionada] = useState('0');

    // Filtros
    const [statusFiltro, setStatusFiltro] = useState("TODOS");
    const [tipoOperacaoFiltro, setTipoOperacaoFiltro] = useState("TODOS");
    const [buscaTexto, setBuscaTexto] = useState("");

    // Modais
    const [showDetails, setShowDetails] = useState(false);
    const [showLog, setShowLog] = useState(false);
    const [selected, setSelected] = useState(null);
    const [fotoSelected, setFotoSelected] = useState(null);
    const [logs, setLogs] = useState([]);
    const [fotoSelecionada, setFotoSelecionada] = useState(null);

    // VERIFICAÇÃO DE PERMISSÃO DE ACESSO
    useEffect(() => {
        const temPermissao = localStorage.getItem("permiteComunido") === "S";

        if (!temPermissao) {
            Swal.fire({
                icon: 'error',
                title: 'Acesso Negado',
                text: 'Você não tem permissão para acessar a Consulta de Comunicados da Loja.',
                confirmButtonColor: '#991b1b'
            }).then(() => {
                navigate('/arbor/home');
            });
            return;
        }

        const lojaStorage = localStorage.getItem("loja") || '0';
        const lojas = JSON.parse(localStorage.getItem("lojasPermitidas") || "[]");

        setLojasPermitidas(lojas);
        setLojaSelecionada(lojaStorage);
    }, [navigate]);

    const carregarComunicadosLoja = async (loja) => {
        const temPermissao = localStorage.getItem("permiteComunido") === "S";
        if (!temPermissao) return;

        setLoading(true);
        setLimiteExibicao(ITENS_POR_PAGINA);
        try {
            const chapaAtual = localStorage.getItem("chapa") || "";
            const filialParam = (loja === '0' || !loja) ? (lojasPermitidas.join(',') || '999') : loja;

            const response = await api.get(`/usuario/comunicacao/gerente?chapa=${chapaAtual}&filial=${filialParam}`);
            setComunicados(response.data || []);
        } catch (err) {
            console.error("Erro ao carregar comunicados da loja:", err);
            setComunicados([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (localStorage.getItem("permiteComunido") === "S") {
            carregarComunicadosLoja(lojaSelecionada);
        }
    }, [lojaSelecionada, lojasPermitidas]);

    const handleLojaChange = (e) => {
        const novaLoja = e.target.value;
        setLojaSelecionada(novaLoja);
        localStorage.setItem("loja", novaLoja);
    };

    useEffect(() => {
        setLimiteExibicao(ITENS_POR_PAGINA);
    }, [statusFiltro, tipoOperacaoFiltro, buscaTexto]);

    const comunicadosFiltrados = useMemo(() => {
        return comunicados.filter(item => {
            if (statusFiltro !== "TODOS" && String(item.status) !== String(statusFiltro)) {
                return false;
            }

            if (tipoOperacaoFiltro !== "TODOS" && String(item.tipooperacao) !== String(tipoOperacaoFiltro)) {
                return false;
            }

            if (buscaTexto.trim() !== "") {
                const termo = buscaTexto.toLowerCase().trim();
                const nomeMatch = String(item.nome || "").toLowerCase().includes(termo);
                const chapaMatch = String(item.chapa || "").toLowerCase().includes(termo);
                const codMatch = String(item.cod_operacao || "").toLowerCase().includes(termo);

                if (!nomeMatch && !chapaMatch && !codMatch) return false;
            }

            return true;
        });
    }, [comunicados, statusFiltro, tipoOperacaoFiltro, buscaTexto]);

    const comunicadosPaginados = useMemo(() => {
        return comunicadosFiltrados.slice(0, limiteExibicao);
    }, [comunicadosFiltrados, limiteExibicao]);

    const handleCarregarMais = () => {
        setLimiteExibicao(prev => prev + ITENS_POR_PAGINA);
    };

    const handleOpenDetails = async (item) => {
        setSelected(item);
        setFotoSelected(null);

        if (item.chapa) {
            const hoje = new Date().toISOString().slice(0, 10);
            const chave = `func_${item.chapa}_${hoje}`;
            if (fotoCache.has(chave)) {
                setFotoSelected(fotoCache.get(chave));
            } else {
                try {
                    const res = await api.get(`/usuario/foto/${item.chapa}`);
                    if (res.data?.foto) {
                        fotoCache.set(chave, res.data.foto);
                        setFotoSelected(res.data.foto);
                    }
                } catch (e) { }
            }
        }

        setShowDetails(true);
    };

    const fetchLogs = async (codigo) => {
        setLoadingLog(true);
        try {
            const response = await api.get(`/usuario/comunicacao/log/${codigo}`);
            setLogs(response.data || []);
            setShowLog(true);
        } catch (err) {
            console.error("Erro ao carregar logs:", err);
            setLogs([]);
        } finally {
            setLoadingLog(false);
        }
    };

    return (
        <div style={{ position: 'relative', width: '100%' }}>
            <style>{`
                .card-header-red {
                    background-color: #991b1b !important;
                    color: #fff !important;
                }
            `}</style>

            <Menu modulo="ARBOR" />

            <div className="container-fluid px-2 px-md-4 pb-5 mb-5" style={{ marginTop: '75px', minHeight: '80vh' }}>
                <div className="d-flex justify-content-between align-items-center border-bottom pb-3 mb-3 flex-wrap gap-2 bg-white p-3 rounded shadow-sm">
                    <div>
                        <h4 className="m-0 fw-bold d-flex align-items-center gap-2" style={{ color: '#991b1b', fontSize: '1.2rem' }}>
                            <FaStore /> Consulta de Status dos Funcionários
                        </h4>
                        <small className="text-muted d-block mt-1">Acompanhamento de solicitações e movimentações de pessoal</small>
                    </div>

                    <div className="d-flex align-items-center gap-2 flex-wrap w-100 w-md-auto mt-2 mt-md-0">
                        <div className="d-flex align-items-center gap-2 bg-light p-2 rounded border flex-fill">
                            <Form.Label className="m-0 text-dark small fw-bold text-nowrap d-flex align-items-center gap-1">
                                <FaStore className="text-danger" /> Loja:
                            </Form.Label>
                            <Form.Select
                                size="sm"
                                style={{ fontWeight: 'bold' }}
                                value={lojaSelecionada}
                                onChange={handleLojaChange}
                            >
                                <option value="0">Todas Permitidas</option>
                                {lojasPermitidas.map((lj) => (
                                    <option key={lj} value={lj}>
                                        Loja {String(lj).padStart(2, '0')}
                                    </option>
                                ))}
                            </Form.Select>
                        </div>

                        <div className="d-flex align-items-center gap-2 bg-light p-2 rounded border flex-fill">
                            <Form.Label className="m-0 text-dark small fw-bold text-nowrap">Tipo:</Form.Label>
                            <Form.Select
                                size="sm"
                                style={{ fontWeight: 'bold' }}
                                value={tipoOperacaoFiltro}
                                onChange={e => setTipoOperacaoFiltro(e.target.value)}
                            >
                                <option value="TODOS">Todos</option>
                                <option value="1">1 - Transferência</option>
                                <option value="2">2 - Alteração Salarial</option>
                                <option value="3">3 - Férias</option>
                            </Form.Select>
                        </div>
                    </div>
                </div>

                <div className="card shadow-sm border-0 mb-3 bg-white">
                    <div className="card-body p-2 p-md-3">
                        <Row className="align-items-center g-2">
                            <Col xs={12} md={6}>
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text bg-light text-muted">
                                        <FaSearch />
                                    </span>
                                    <Form.Control
                                        type="text"
                                        placeholder="Buscar por Nome, Matrícula ou Nº Op..."
                                        value={buscaTexto}
                                        onChange={e => setBuscaTexto(e.target.value)}
                                    />
                                    {buscaTexto && (
                                        <Button variant="outline-secondary" onClick={() => setBuscaTexto('')}>
                                            <FaTimes />
                                        </Button>
                                    )}
                                </div>
                            </Col>

                            <Col xs={12} md={6} className="d-flex justify-content-md-end align-items-center gap-2">
                                <Form.Label className="m-0 text-muted small fw-bold text-nowrap d-flex align-items-center gap-1">
                                    <FaFilter /> Status:
                                </Form.Label>
                                <Form.Select
                                    size="sm"
                                    style={{ fontWeight: 'bold' }}
                                    value={statusFiltro}
                                    onChange={e => setStatusFiltro(e.target.value)}
                                >
                                    <option value="TODOS">Todos os Status</option>
                                    <option value="1">1 - Em Aprov. Regional</option>
                                    <option value="2">2 - Em Validação RH</option>
                                    <option value="3">3 - Em Aprov. Dependentes</option>
                                    <option value="4">4 - Em Aprov. Diretoria</option>
                                    <option value="5">5 - Lançamento RH</option>
                                    <option value="6">6 - Ciência do Func.</option>
                                    <option value="10">10 - Concluído</option>
                                    <option value="11">11 - Negado Loja Destino</option>
                                    <option value="12">12 - Negado Regional</option>
                                    <option value="13">13 - Negado RH</option>
                                </Form.Select>
                            </Col>
                        </Row>
                    </div>
                </div>

                <div className="card shadow-sm border-0 bg-white d-none d-md-block">
                    <div className="card-body p-0">
                        <Table responsive hover className="m-0 align-middle">
                            <thead className="table-light">
                                <tr>
                                    <th className="px-3">Nº Op.</th>
                                    <th>Matrícula</th>
                                    <th>Funcionário</th>
                                    <th>Tipo Operação</th>
                                    <th>A partir de (Data)</th>
                                    <th className="text-center">Status Atual</th>
                                    <th className="text-center">Ações</th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: '0.88rem' }}>
                                {comunicadosPaginados.length > 0 ? (
                                    comunicadosPaginados.map((item) => (
                                        <tr key={item.cod_operacao}>
                                            <td className="px-3 fw-bold">#{item.cod_operacao}</td>
                                            <td>
                                                <div className="d-flex align-items-center gap-2">
                                                    <FotoAvatarMini
                                                        chapa={item.chapa}
                                                        nome={item.nome}
                                                        filial={item.filial}
                                                        onSelectFoto={setFotoSelecionada}
                                                    />
                                                    <span className="badge bg-light text-dark border">{item.chapa}</span>
                                                </div>
                                            </td>
                                            <td className="fw-bold">{item.nome}</td>
                                            <td>{item.tipo || item.tipooperacao}</td>
                                            <td className="fw-semibold text-danger">
                                                {formatarDataSemFuso(item.dataefetivo)}
                                            </td>
                                            <td className="text-center">
                                                {getBadgeStatus(item.status)}
                                            </td>
                                            <td className="text-center">
                                                <Button
                                                    variant="outline-primary"
                                                    size="sm"
                                                    className="py-1 px-2 d-inline-flex align-items-center gap-1"
                                                    onClick={() => handleOpenDetails(item)}
                                                >
                                                    <FaEye /> Visualizar
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="text-center text-muted py-4">
                                            Nenhum registro encontrado para os filtros selecionados.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </div>

                <div className="d-block d-md-none">
                    {comunicadosPaginados.length > 0 ? (
                        comunicadosPaginados.map((item) => (
                            <Card key={item.cod_operacao} className="mb-2 border shadow-sm bg-white">
                                <Card.Body className="p-3">
                                    <div className="d-flex justify-content-between align-items-start border-bottom pb-2 mb-2">
                                        <div className="d-flex align-items-center gap-2">
                                            <FotoAvatarMini
                                                chapa={item.chapa}
                                                nome={item.nome}
                                                filial={item.filial}
                                                onSelectFoto={setFotoSelecionada}
                                            />
                                            <div>
                                                <span className="fw-bold d-block text-uppercase" style={{ fontSize: '0.85rem' }}>{item.nome}</span>
                                                <small className="text-muted">Matrícula: <strong>{item.chapa}</strong></small>
                                            </div>
                                        </div>
                                        <span className="badge bg-dark">#{item.cod_operacao}</span>
                                    </div>

                                    <div className="row g-2 small text-muted mb-2">
                                        <div className="col-6">
                                            <span>Tipo:</span>
                                            <div className="fw-bold text-dark">{item.tipo || item.tipooperacao}</div>
                                        </div>
                                        <div className="col-6">
                                            <span>A partir de:</span>
                                            <div className="fw-bold text-danger">{formatarDataSemFuso(item.dataefetivo)}</div>
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-between align-items-center border-top pt-2 mt-2">
                                        <div>{getBadgeStatus(item.status)}</div>
                                        <Button
                                            variant="outline-primary"
                                            size="sm"
                                            className="py-1 px-2 d-inline-flex align-items-center gap-1"
                                            onClick={() => handleOpenDetails(item)}
                                        >
                                            <FaEye /> Detalhes
                                        </Button>
                                    </div>
                                </Card.Body>
                            </Card>
                        ))
                    ) : (
                        <Card className="p-4 text-center text-muted border-0 bg-white shadow-sm">
                            Nenhum registro encontrado para os filtros selecionados.
                        </Card>
                    )}
                </div>

                {comunicadosFiltrados.length > limiteExibicao && (
                    <div className="text-center mt-4">
                        <Button
                            variant="danger"
                            className="px-4 py-2 fw-bold d-inline-flex align-items-center gap-2 shadow-sm"
                            style={{ backgroundColor: '#991b1b', borderColor: '#991b1b' }}
                            onClick={handleCarregarMais}
                        >
                            <FaChevronDown /> Exibir Mais (Mostrando {limiteExibicao} de {comunicadosFiltrados.length})
                        </Button>
                    </div>
                )}
            </div>

            {/* Modal de Detalhes */}
            <Modal show={showDetails} onHide={() => setShowDetails(false)} size="lg" centered>
                <Modal.Header closeButton className="card-header-red">
                    <Modal.Title className="fs-6 fw-bold">
                        Consulta de Comunicado <span className="text-warning">#{selected?.cod_operacao}</span>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="p-3">
                    {selected && (
                        <div className="row m-0">
                            <div className="col-md-4 text-center border-end pe-md-3 mb-3 mb-md-0">
                                {fotoSelected ? (
                                    <img
                                        src={`data:image/jpeg;base64,${fotoSelected}`}
                                        className="img-fluid rounded shadow-sm mb-2"
                                        alt="User"
                                        style={{ cursor: 'pointer', width: '100%', maxHeight: '160px', objectFit: 'cover', borderRadius: '6px' }}
                                        onClick={() => setFotoSelecionada({
                                            foto: `data:image/jpeg;base64,${fotoSelected}`,
                                            nome: selected?.nome,
                                            info01: `Matrícula: ${selected?.chapa}`,
                                            info02: `Loja ${String(selected?.filial || '').padStart(2, '0')}`
                                        })}
                                    />
                                ) : (
                                    <div className="my-2 text-secondary">
                                        <span style={{ fontSize: '3rem' }}>👤</span>
                                    </div>
                                )}
                                <h6 className="fw-bold mb-1 text-uppercase" style={{ fontSize: '0.85rem' }}>{selected.nome}</h6>
                                <p className="text-muted small mb-2">Matrícula: <strong>{selected.chapa}</strong></p>

                                <div className="mb-2">
                                    <Badge bg="info" className="text-dark fw-bold px-2 py-1">
                                        {selected.tipo || selected.tipooperacao}
                                    </Badge>
                                </div>

                                <div className="mb-3">
                                    <span className="d-block text-muted small">Status Atual:</span>
                                    {getBadgeStatus(selected.status)}
                                </div>

                                <Button
                                    variant="outline-secondary"
                                    size="sm"
                                    className="w-100 py-1 d-flex align-items-center justify-content-center gap-1"
                                    onClick={() => fetchLogs(selected.cod_operacao)}
                                    disabled={loadingLog}
                                >
                                    {loadingLog ? <Spinner animation="border" size="sm" /> : <><FaHistory /> Ver Histórico (Logs)</>}
                                </Button>
                            </div>

                            <div className="col-md-8 ps-md-3">
                                <div className="row mb-2">
                                    <div className="col-6">
                                        <label className="text-muted small d-block">Loja Origem</label>
                                        <div className="fw-bold small">{selected.filial}</div>
                                    </div>
                                    <div className="col-6">
                                        <label className="text-muted small d-block">Loja Destino</label>
                                        <div className="fw-bold small" style={{ color: '#991b1b' }}>{selected.lojades || '--'}</div>
                                    </div>
                                </div>

                                <div className="row mb-2">
                                    <div className="col-6">
                                        <label className="text-muted small d-block">Setor Atual</label>
                                        <div className="small">{selected.setor || '--'}</div>
                                    </div>
                                    <div className="col-6">
                                        <label className="text-muted small d-block">Novo Setor</label>
                                        <div className="small fw-bold" style={{ color: '#991b1b' }}>{selected.descsetornovo || selected.setornovo || '--'}</div>
                                    </div>
                                </div>

                                <div className="row mb-2">
                                    <div className="col-6">
                                        <label className="text-muted small d-block">Função Atual</label>
                                        <div className="small">{selected.funcao || '--'}</div>
                                    </div>
                                    <div className="col-6">
                                        <label className="text-muted small d-block">Nova Função</label>
                                        <div className="small fw-bold" style={{ color: '#991b1b' }}>{selected.descfuncnova || selected.funcaonova || '--'}</div>
                                    </div>
                                </div>

                                <div className="row mb-2">
                                    <div className="col-6">
                                        <label className="text-muted small d-block">Salário Atual</label>
                                        <div className="small">{formatMoeda(selected.salario)}</div>
                                    </div>
                                    <div className="col-6">
                                        <label className="text-muted small d-block">Novo Salário</label>
                                        <div className="small fw-bold" style={{ color: '#991b1b' }}>{formatMoeda(selected.salarionovo)}</div>
                                    </div>
                                </div>

                                <div className="p-2 bg-light border rounded mt-3">
                                    <label className="text-muted small d-block">Data Efetiva da Mudança / Início:</label>
                                    <div className="fw-bold fs-6" style={{ color: '#991b1b' }}>
                                        {formatarDataSemFuso(selected.dataefetivo)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </Modal.Body>

                <Modal.Footer className="bg-light">
                    <Button variant="secondary" size="sm" onClick={() => setShowDetails(false)}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* MODAL DE LOGS RESPONSIVO */}
            <Modal show={showLog} onHide={() => setShowLog(false)} size="lg" centered>
                <Modal.Header closeButton className="card-header-red">
                    <Modal.Title className="fs-6 fw-bold">Histórico de Mutações do Comunicado</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-2 p-md-3" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                    {logs && logs.length > 0 ? (
                        <>
                            {/* VISÃO DESKTOP (Tabela) */}
                            <div className="d-none d-md-block">
                                <Table striped hover responsive size="sm" className="m-0 align-middle">
                                    <thead className="table-secondary">
                                        <tr>
                                            <th>Data/Hora</th>
                                            <th>Usuário</th>
                                            <th>Status</th>
                                            <th>Observação</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{ fontSize: '0.85rem' }}>
                                        {logs.map((l, index) => (
                                            <tr key={index}>
                                                <td className="text-nowrap">{l.hora ? new Date(l.hora).toLocaleString('pt-BR') : ''}</td>
                                                <td><strong>{l.nome}</strong> ({l.usuario})</td>
                                                <td><Badge bg="info">{l.descstatus}</Badge></td>
                                                <td>{l.observacaolog || '-'}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>

                            {/* VISÃO MOBILE (Lista Timeline / Cards Compactos) */}
                            <div className="d-block d-md-none">
                                {logs.map((l, index) => (
                                    <div key={index} className="p-2.5 mb-2 bg-light border rounded shadow-sm">
                                        <div className="d-flex justify-content-between align-items-center mb-1">
                                            <Badge bg="info" className="text-dark fw-bold" style={{ fontSize: '0.75rem' }}>
                                                {l.descstatus}
                                            </Badge>
                                            <small className="text-muted fw-semibold" style={{ fontSize: '0.75rem' }}>
                                                {l.hora ? new Date(l.hora).toLocaleString('pt-BR') : ''}
                                            </small>
                                        </div>
                                        
                                        <div className="fw-bold text-dark mb-1" style={{ fontSize: '0.82rem' }}>
                                            👤 {l.nome} <span className="text-muted font-normal">({l.usuario})</span>
                                        </div>

                                        {l.observacaolog && (
                                            <div className="p-2 bg-white border rounded text-secondary mt-1" style={{ fontSize: '0.78rem', wordBreak: 'break-word' }}>
                                                💬 {l.observacaolog}
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </>
                    ) : (
                        <div className="text-center text-muted py-4">
                            Nenhum histórico disponível para este comunicado.
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className="bg-light p-2">
                    <Button variant="secondary" size="sm" onClick={() => setShowLog(false)}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>

            <Footer />

            <Foto
                show={!!fotoSelecionada}
                onClose={() => setFotoSelecionada(null)}
                foto={fotoSelecionada?.foto}
                nome={fotoSelecionada?.nome}
                info01={fotoSelecionada?.info01}
                info02={fotoSelecionada?.info02}
            />

            {/* MODAL DE LOADING PADRONIZADO */}
            <Modal 
                show={loading} 
                backdrop="static" 
                keyboard={false} 
                centered 
                size="sm"
                contentClassName="border-0 shadow-lg"
            >
                <Modal.Body className="text-center p-4 rounded bg-white">
                    <Spinner animation="border" style={{ color: '#991b1b' }} />
                    <div className="mt-2 fw-bold text-dark" style={{ fontSize: '0.95rem' }}>
                        Carregando...
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default ConsultaGerente;